import { LocalStyles } from "@paperbits/common/styles";

export class ProductSubscribeModel {
    /**
     * Controls whether legal text is displayed by default or not.
     */
    public showTermsByDefault: boolean;

    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
